import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map, mergeAll, mergeMap, of, pipe, Subject, switchMap, toArray } from 'rxjs';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CategoryService } from 'src/app/core/services/category.service';
import { CommonService } from 'src/app/core/services/common.service';
import { QuestionControlService } from 'src/app/core/services/question-control.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { QuestionValidationService } from 'src/app/core/services/question-validation.service';
import { Location } from '@angular/common';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';

@Component({
  selector: 'app-subcategory',
  templateUrl: './subcategory.component.html',
  styleUrls: ['./subcategory.component.css']
})
export class SubcategoryComponent implements OnInit {
  @Input()
  category!: string;
  @Input()
  subcategory!: string;
  @Input() isLastSection: any;
  @Input() isLastCategory: any;
  @Input() isLastSubcategory: any;
  @Input() unansweredQues: any;
  @Input() returnQues!: any;
  @Output() subcategoryStatusCheck: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetReturnQues: EventEmitter<any> = new EventEmitter<any>();
  @Output() completedChange = new EventEmitter<boolean>();

  saveNextSubject: Subject<void> = new Subject<void>();
  quesSubmitMapper: any = {};
  allQuestions!: any;
  controlAssessmentForm = new FormGroup({});
  isCompleted = false;
  questionsList: any = [];
  isquesValid = false;
  selectedQues = 0;
  formLoaded = false;
  isArabic!: boolean;
  userDetails!: any;
  assessmentDetails!: any;
  questionaireguid!: any;
  quesguid!: any;
  allAnswers!: any;
  questionnaireType!: string;
  subscription: any;
  parentQuesAns: any;
  totalQues: any;
  quesPercentage: any;
  fileToUpload: File | null = null;
  fileToUploadBase64: any;
  fileSize: any;
  fileName: any;
  showSizeErr: any;
  responseId: any;
  questionnaireAccountGuid: any;
  ifAlreadySubmitted: any;
  isFileUploaded!: any;
  fileUploadErr!: boolean;
  fileTypeErr!: boolean;
  uploadedFile: any;
  isUploadedFileAvailable!: boolean;
  isFileChanged!: boolean;
  isResubmit: any;
  isView: any;
  isChecker: any;
  showCommentErr: any;
  showNumericCommentErr: any;
  showAlphanumericCommentErr: any;
  isMakerCheckerEnabled: any;
  status: any;
  quesDescription: any;
  answeredCount: any;
  resubmittedCount: number = 0
  modalRef!: BsModalRef;
  modalRefDeactivate!: BsModalRef;
  submitted: any;
  subscriptionNotify: any;
  disableSaveNext: any = false;
  serverErr: any;
  executorResp: any = [];
  isCountChange: boolean = false;
  reVisitUnAnswered: boolean = false;
  returnToAssessment: boolean = false;
  checkerHistory!: any;
  checkerComment!: any;
  isUploading = false;
  uploadProgress = 0; // percentage 0 - 100
  totalFilesToUpload = 0;
  filesUploadedCount = 0;
  files: Array<{
    filename: string;
    ownername: string;
    documentBody?: string;
    isExisting: boolean;
    mimetype: string;
  }> = [];
  fileNames: string[] = [];
  crmFiles: Array<{
    filename: string;
    ownername: string;
    documentBody?: string;      // base64 string for newly added files; undefined/null for existing files
    isExisting: boolean;
    mimetype: string;  // true for existing files from backend, false for newly added files
  }> = [];
  crmFileNames: string[] = [];
  fileDataBase64: string[] = [];
  allowedOwners = ['AML CRMINT', 'AML CRM PROD'];

  @ViewChild('fileInputElem') fileInputElem!: ElementRef<HTMLInputElement>;
  @ViewChildren('fileInputPerFile') fileInputs!: QueryList<ElementRef<HTMLInputElement>>;

  openFileDialog() {
    if (this.fileInputElem) {
      this.fileInputElem.nativeElement.click();
    }
  }
  // ratings = [{name:'Effective', value: '3'}, {name:'Not Effective', value: '1'}, {name:'Partially Effective', value: '2'}];
  @ViewChild('tooltipTrigger', { static: false }) public tooltip!: TooltipDirective;
  constructor(private qcs: QuestionControlService, private activateRoute: ActivatedRoute, private storageService: StorageService,
    private assessmentService: AssessmentService, private commonService: CommonService, private categoryService: CategoryService,
    private route: Router, private modalService: BsModalService, private quesValidationService: QuestionValidationService,
    private location: Location, private cd: ChangeDetectorRef) { }

  @HostListener('window:click', ['$event'])
  onClick(event: any) {
    // console.log(event);
    if (event.target.id != 'tooltipIcon' && this.tooltip) {
      this.tooltip.hide();
    }
  }

  ngOnInit(): void {

    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.assessmentDetails = this.storageService.getSessionStorageData('assessmentDetails');
    this.questionnaireAccountGuid = this.assessmentDetails.questionnaireAccountGuid;

    this.activateRoute.queryParams.subscribe((queryParam: any) => {
      this.reVisitUnAnswered = false;
      this.returnToAssessment = false;
      if (queryParam.hasOwnProperty('action') && queryParam.action == 'resubmit') {
        this.isResubmit = true;
        this.isView = false;
      } else if (queryParam.hasOwnProperty('action') && queryParam.action == 'view') {
        this.isResubmit = false;
        this.isView = true;
      } else {
        this.isResubmit = false;
        this.isView = false;
      }
      if (queryParam.hasOwnProperty('revisittype') && queryParam.revisittype == 'unanswered') {
        this.reVisitUnAnswered = true;
      }
      else if (queryParam.hasOwnProperty('revisittype') && queryParam.revisittype == 'return') {
        this.returnToAssessment = true;
      }
    });
    this.subscription = this.activateRoute.queryParams.subscribe((queryParam: any) => {
      if (queryParam.hasOwnProperty('questionnairetype')) {
        this.questionnaireType = queryParam.questionnairetype;
        this.questionaireguid = this.assessmentDetails.questionnaireguid;
        this.fetchSubcategoryQuestions();
      }
    });
  }
  // Called when user clicks edit icon next to a particular file index
  triggerFileInputForIndex(index: number) {
    const inputElem = this.fileInputs?.toArray()[index];
    if (inputElem) {
      inputElem.nativeElement.click();
    }
  }
  // Handles replacing single file at index 'i' on file selection from hidden input
  handleSingleFileReplace(event: Event, fileIndex: number) {
    const inputEl = event.target as HTMLInputElement;
    if (!inputEl.files || inputEl.files.length === 0) return;

    const selectedFile = inputEl.files[0];
    const allowedExtensions = ['pdf', 'jpeg'];
    const maxSizeBytes = 20 * 1024 * 1024;
    let ext = selectedFile.name.split('.').pop()?.toLowerCase() || '';

    // Validate extension
    if (!allowedExtensions.includes(ext)) {
      this.fileTypeErr = true;
      return;
    }

    // Validate size
    if (selectedFile.size > maxSizeBytes) {
      this.showSizeErr = true;
      return !this.isArabic ? alert('Total size of newly selected files exceeds the 20 MB limit. Please select fewer or smaller files.') : alert('يجب ألا يتجاوز الحجم الإجمالي لجميع الملفات المضافة حديثًا 20 ميجابايت.');
    }

    this.commonService.fileToBase64(selectedFile)
      .then(base64String => {
        const currentQues = this.allQuestions[0].fields[this.selectedQues];

        // Make sure 'files' array exists
        if (!Array.isArray(currentQues.files)) {
          currentQues.files = [];
        }

        // Replace file object at the given index with new data
        currentQues.files[fileIndex] = {
          filename: selectedFile.name,
          documentbody: base64String,
          isExisting: false,    // Because user replaced it with a new one
        };

        this.isFileUploaded = true;
        this.fileTypeErr = false;
        this.showSizeErr = false;

        // Reset input so user can reselect same file if needed
        inputEl.value = '';
      })
      .catch(err => {
        console.error('Error converting file to base64:', err);
        this.isFileUploaded = false;
      });
  }
  fetchSubcategoryQuestions() {
    let rqstBody: any;
    // if (this.isResubmit) {
    //   rqstBody = {
    //     questionnaire: this.questionaireguid,
    //     assessmentType: this.questionnaireType,
    //     category: this.category,
    //     subcategory: this.subcategory,
    //     isResubmit: this.isResubmit,
    //     ques: this.assessmentDetails.quesguid,
    //     isChecker: this.isChecker
    //   };
    // } else {
    //   rqstBody = {
    //     questionnaire: this.questionaireguid,
    //     assessmentType: this.questionnaireType,
    //     category: this.category,
    //     subcategory: this.subcategory,
    //     isResubmit: this.isResubmit,
    //     isChecker: this.isChecker
    //   };
    // }
    rqstBody = {
      questionnaire: this.questionaireguid,
      assessmentType: this.questionnaireType,
      category: this.category,
      subcategory: this.subcategory,
      isResubmit: this.isResubmit,
      isChecker: this.isChecker
    };
    // console.log('rqstBody of total questions: ', rqstBody);
    this.assessmentService.fetchAssessmentQuestions(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));

      //console.log('finally questions list in control assessment: ', resp);
      this.questionsList[0] = resp.questionsList;
      this.totalQues = resp.questionsList.totalQuestions;
      // console.log('total number of questions: ', this.totalQues);
      this.storageService.setSessionStorageData('totalQues', this.totalQues);
      let basicPercentage = (100 / Number(this.totalQues));
      this.quesPercentage = this.calculateDecimalValue(basicPercentage);
      // this.quesPercentage = (100 / Number(this.totalQues)).toFixed(2);

      this.fetchAndGenerateForm();
    });
  }

  calculateDecimalValue(basicPercentage: any) {

    let strPercent = basicPercentage.toString();
    let arrPercent = strPercent.split('.');
    let final;
    if (arrPercent[1]) {
      //final = arrPercent[0] + '.' + arrPercent[1]?.substring(0, 2);
      final = arrPercent[0] + '.' + arrPercent[1]?.substring(0, 5);
    } else {
      final = arrPercent[0];
    }
    return Number(final);
  }

  fetchAndGenerateForm() {
    let selectedAllQuestions = this.questionsList.filter((ele: any) => ele.categoryName === this.category && ele.subcategoryName === this.subcategory);
    this.allQuestions = selectedAllQuestions[0]?.zones;
    // console.log('all questions :',this.allQuestions);
    // console.log('Zones and fields:', this.allQuestions);

    this.allQuestions?.forEach((zone: any) => {
      zone.fields.forEach((field: any) => {
        field.controls.forEach((control: any) => {
          if (control.options && control.options.length) {
            // console.log('Dropdown options for question', field.quesId, ':', control.options);
          }
        });
      });
    });
    const unfilteredAllQuestionList = this.allQuestions;

    this.allQuestions = this.allQuestions?.map((zone: any) => {
      zone.fields = zone?.fields?.filter((ele: any) => ele.categoryName === this.category && ele.subcategoryName === this.subcategory)
      return zone;
    });

    const rqstBody = {
      questionnaire: this.questionaireguid,
      assessmentUnit: this.userDetails.assessmentUnitValue
    }
    this.assessmentService.fetchExecutorResponses(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      // console.log('finally responses list in control assessment: ', resp);
      this.allAnswers = resp.executorResponses;

      if (this.isResubmit) {

        const REJECTED_STATUS = this.isChecker ?
          GlobalConstants.STATUSES.REJECTED.name :
          (this.isMakerCheckerEnabled ?
            GlobalConstants.STATUSES.CHECKER_REJECTED.name :
            GlobalConstants.STATUSES.REJECTED.name);
        // console.log("REJECTED_STATUS",REJECTED_STATUS)
        this.allQuestions = this.allQuestions?.map((zone: any) => {
          zone.fields = zone?.fields?.filter((question: any) => {
            const answer = this.allAnswers?.find((eachAnswer: any) => eachAnswer.ques === question.quesguid);
            const isRejectedOrDraft = (answer?.statusOfResponse == REJECTED_STATUS ||
              answer?.statusOfResponse == GlobalConstants.STATUSES.DRAFT.name) ? true : false;
            // console.log("each ques status:", answer?.statusOfResponse)
            return isRejectedOrDraft;
          })
          return zone;
        })
      }

      this.controlAssessmentForm = this.qcs.toFormGroup(this.allQuestions, this.controlAssessmentForm, this.allAnswers);
      //console.log('controlAssessmentForm', this.controlAssessmentForm);

      if (this.controlAssessmentForm.controls) {
        this.formLoaded = true;
        this.selectedQues = 0;
        // this.responseId = this.allQuestions[0]?.fields[this.selectedQues]?.responseId;
        // this.executorResp = new Array(this.allQuestions[0].fields[this.selectedQues].controls.length);
        if (this.allQuestions?.length >= 0) {
          this.allQuestions[0]?.fields[this.selectedQues]?.controls?.forEach((ele: any) => {
            this.executorResp?.push({ isValid: undefined, value: undefined })
          });
        }
        if (this.reVisitUnAnswered && this.unansweredQues) {
          this.selectedQues = unfilteredAllQuestionList[0]?.fields.findIndex((ques: any) => ques.quesguid == this.unansweredQues.quesguid);
        }
        if (this.returnToAssessment && this.returnQues && this.returnQues?.selectedQues) {
          this.selectedQues = this.returnQues?.selectedQues;
          this.resetReturnQues.emit();
        }
        // if (this.isView || this.isResubmit) {
          this.setQuestionVisibility();
        // }
        this.setSelectedQuestionState();
        // console.log('all questions list :',this.allQuestions[0]?.fields[this.selectedQues]);
        this.fetchUploadedFiles();
        this.disableSaveNext = false;
      }
    });
  }

  setSelectedQuestionState() {
    const selectedQuestionState = {
      questionaireguid: this.questionaireguid,
      questionnaireType: this.questionnaireType,
      category: this.category,
      subcategory: this.subcategory,
      selectedQues: this.selectedQues
    }
    this.storageService.setSessionStorageData('selectedQuestionState', selectedQuestionState);
  }

  editNotes(fileId: any) {
    //  console.log('fileId',fileId);
    let element: HTMLElement = document.getElementById(fileId) as HTMLElement;
    element.click();
  }
  deleteNotes() {
    const currentQues = this.allQuestions[0].fields[this.selectedQues];

    if (!currentQues.responseId) {
      // No response IDs means no files to delete on server, just clear locally
      currentQues.fileNames = [];
      currentQues.fileDataBase64 = [];
      this.isFileUploaded = undefined;
      return;
    }

    const rqstBody = {
      responseguid: currentQues.responseId
    };

    this.assessmentService.deleteFileFromServer(rqstBody).subscribe({
      next: (data: any) => {
        let decryptedData = this.commonService.decryptUsingAES256(data?.data);
        // Optionally check success from decryptedData before clearing

        // Clear local data after delete confirmation
        currentQues.fileNames = [];
        currentQues.fileDataBase64 = [];
        this.isFileUploaded = undefined;
      },
      error: (err) => {
        console.error('Failed to delete file(s):', err);
        // Optionally show error message
      }
    });
  }
  deleteNotesOld() {
    if (this.allQuestions[0].fields[this.selectedQues].fileName != null) {
      const rqstBody4 = {
        responseguid: this.allQuestions[0].fields[this.selectedQues].responseId
      }
      this.assessmentService.deleteFileFromServer(rqstBody4).subscribe((data4: any) => {
        let decryptedData3 = this.commonService.decryptUsingAES256(data4?.data);
        // console.log(decryptedData3);
        // console.log("delete file res:",data4);
      });
      //this.fileName = null;
      this.allQuestions[0].fields[this.selectedQues].fileName = null;
      this.isFileUploaded = undefined;
    } else {
      this.allQuestions[0].fields[this.selectedQues].fileName = null;
      this.isFileUploaded = undefined;
    }
  }

  commentsChange(evt: any) {
    // console.log(evt);
    this.allQuestions[0].fields[this.selectedQues].comments = evt?.target?.value;
  }

  fetchUploadedFile() {
    if (this.allQuestions[0].fields[this.selectedQues]?.responseId !== undefined &&
      this.allQuestions[0].fields[this.selectedQues]?.responseId !== null) {
      const rqstBody = {
        responseguid: this.allQuestions[0].fields[this.selectedQues]?.responseId,
        type: "question"
      }
      this.assessmentService.fetchUploadedFile(rqstBody).subscribe((res) => {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        // console.log('finally files in control assessment: ', resp);
        this.uploadedFile = resp?.documentbody;
        if (this.uploadedFile || resp?.filename) {
          this.isUploadedFileAvailable = true;
          this.allQuestions[0].fields[this.selectedQues].fileName = resp?.filename;
        } else {
          this.allQuestions[0].fields[this.selectedQues].fileName = null;
        }
        // console.log('uploaded file is:', this.uploadedFile);

      });
    }
  }
  isDownload = false
  fetchUploadedFiles() {
    const responseId = this.allQuestions[0].fields[this.selectedQues]?.responseId;
    if (responseId !== undefined && responseId !== null) {
      const rqstBody = {
        responseguid: responseId,
        type: "question",
        isMultipleFiles: true,
        isDownload: false
      }
      this.assessmentService.fetchUploadedFile(rqstBody).subscribe((res) => {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        // Assuming resp is an array of files like:
        // [{ filename: "file1.pdf", documentbody: "base64..." }, { filename: "file2.jpg", documentbody: "base64..." }, ...]
        if (Array.isArray(resp) && resp.length > 0) {
          this.isUploadedFileAvailable = true;
          // First add isExisting: true on all resp:
          const allFilesWithFlag = resp.map(file => ({
            filename: file.filename,
            ownername: file.ownername,
            mimetype: file.mimetype,
            base64: file.documentbody,
            isExisting: true,
            annotationid: file.annotationid,
          }));

          this.files = allFilesWithFlag.filter(file => this.allowedOwners.includes(file.ownername));
          this.allQuestions[0].fields[this.selectedQues].files = this.files;
          // Similarly filter crmFiles with same approach:
          this.crmFiles = allFilesWithFlag.filter(file => !this.allowedOwners.includes(file.ownername));
          this.allQuestions[0].fields[this.selectedQues].crmFiles = this.crmFiles;

          // Update file names:
          this.allQuestions[0].fields[this.selectedQues].fileNames = this.files.map(f => f.filename);
          this.allQuestions[0].fields[this.selectedQues].crmFileNames = this.crmFiles.map(f => f.filename);
          // console.log("files", this.allQuestions[0].fields[this.selectedQues].fileNames)
          // console.log("crmFileNames", this.allQuestions[0].fields[this.selectedQues].crmFileNames)

          this.allQuestions[0].fields[this.selectedQues].showDocuments = true;
          this.allQuestions[0].fields[this.selectedQues].showCrmDocuments = true;



        } else {
          // no files, clear arrays
          this.allQuestions[0].fields[this.selectedQues].files = [];
          this.allQuestions[0].fields[this.selectedQues].fileNames = [];

          this.allQuestions[0].fields[this.selectedQues].crmFiles = [];
          this.allQuestions[0].fields[this.selectedQues].crmFileNames = [];
          this.isUploadedFileAvailable = false;
        }
      });
    }
  }
  download(fileid: any) {
    const responseId = this.allQuestions[0].fields[this.selectedQues]?.responseId;
    if (responseId !== undefined && responseId !== null) {
      const rqstBody = {
        responseguid: responseId,
        annotationId: fileid,
        type: "question",
        isMultipleFiles: false,
        isDownload: true
      }
      this.assessmentService.fetchUploadedFile(rqstBody).subscribe((res) => {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        // Assuming resp is an array of files like:
        // [{ filename: "file1.pdf", documentbody: "base64..." }, { filename: "file2.jpg", documentbody: "base64..." }, ...]
        // console.log("download ", resp)



        const link = document.createElement('a');

        if (resp.documentbody) {
          link.href = `data:application/octet-stream;base64,${resp.documentbody}`;
        } else {
          return;
        }

        link.download = resp.filename || 'download';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
    }
  }
  valueChanged(parentQuesAns: any) {
    this.controlAssessmentForm.get(parentQuesAns.quesId)?.setValue(parentQuesAns?.parentQuesValue);
    // console.log('multiselect:',parentQuesAns);
    this.parentQuesAns = parentQuesAns;
    // this.isquesValid = parentQuesAns.quesValid;
    if (this.parentQuesAns && this.executorResp) {
      this.executorResp[this.parentQuesAns?.index].isValid = this.parentQuesAns?.quesValid;
      this.executorResp[this.parentQuesAns?.index].value = this.parentQuesAns?.parentQuesValue;
    }
    this.showAlphanumericCommentErr = false;
    this.showNumericCommentErr = false;
    this.showCommentErr = false;
    this.disableSaveNext = false;
    this.submitted = false

  }

  // handleFileInput(evt: any, fileId: any, actionType?: any) {
  //   this.showSizeErr = false;
  //   this.fileTypeErr = false;
  //   this.isFileUploaded = false;
  //   let files = evt.target.files;

  //   this.fileToUpload = files[0];
  //   // console.log(files[0])
  //   if (files[0]) {
  //     let ext = files[0]?.name.split('.').pop();
  //     //ext == 'doc' || ext == 'docx' ||
  //     if (ext == 'pdf' || ext == 'jpg' || ext == 'jpeg' || ext == 'png') {
  //       // this.fileName = files[0]?.name;
  //       this.fileSize = files[0]?.size;
  //       // console.log('filename: ',this.fileName);
  //       // console.log('filesize: ',this.fileSize);
  //       this.fileTypeErr = false;

  //       if (this.fileSize > 5000000) {
  //         this.showSizeErr = true;
  //         this.allQuestions[0].fields[this.selectedQues].fileName = null;
  //       } else {
  //         this.showSizeErr = false;
  //         this.allQuestions[0].fields[this.selectedQues].fileName = files[0]?.name;
  //         this.onFileUpload(fileId, actionType);
  //       }


  //     } else {
  //       this.fileTypeErr = true;
  //       this.allQuestions[0].fields[this.selectedQues].fileName = null;
  //     }
  //   } else {

  //     this.fileTypeErr = false;
  //     this.showSizeErr = false;
  //   }

  // }

  isProcessingFiles = false

  async handleFileInput(evt: any, fileId: any, actionType?: any) {
    this.isProcessingFiles = true;
    this.disableSaveNext = true;

    this.showSizeErr = false;
    this.fileTypeErr = false;

    const files: FileList = evt.target.files;
    this.isFileUploaded = files && files.length > 0;
    // console.log('Files selected:', files.length, 'isFileUploaded set to', this.isFileUploaded);
    if (!files || files.length === 0) {
      this.isProcessingFiles = false;
      this.disableSaveNext = false;
      this.cd.detectChanges();
      return;
    }

    const currentQuestion = this.allQuestions[0].fields[this.selectedQues];
    // Defensive initialization
    currentQuestion.files = currentQuestion.files || [];

    // Existing new files (not yet uploaded)
    const currentNewFiles = currentQuestion.files.filter((f: any) => !f.isExisting);

    // Incoming new files array
    const newBatchFilesArr = Array.from(files);

    const MAX_NEW_FILES = 10;
    const MAX_TOTAL_NEW_SIZE = 20 * 1024 * 1024; // 20 MB

    // Helper to estimate base64 size approx if needed
    const estimateFileSizeFromBase64 = (base64String: string): number => {
      if (!base64String) return 0;
      let padding = 0;
      if (base64String.endsWith('==')) padding = 2;
      else if (base64String.endsWith('=')) padding = 1;
      return (base64String.length * 3) / 4 - padding;
    };

    // Calculate size of existing new files
    const sizeOfCurrentNewFiles = currentNewFiles.reduce((acc: number, f: any) => {
      if (f.size) return acc + f.size;
      else return acc + estimateFileSizeFromBase64(f.documentbody);
    }, 0);

    // Sum size of new batch files
    const sizeOfNewBatch = newBatchFilesArr.reduce((acc, f) => acc + f.size, 0);
    const cumulativeSize = sizeOfCurrentNewFiles + sizeOfNewBatch;

    // Validate new files count limit (existing new + new batch)
    if ((currentNewFiles.length + newBatchFilesArr.length) > MAX_NEW_FILES) {
      this.isProcessingFiles = false;
      this.disableSaveNext = false;
      this.cd.detectChanges();
      return !this.isArabic ? alert(`You can only attach up to ${MAX_NEW_FILES} new files.`) : alert(`يمكنك إرفاق ما يصل إلى ${MAX_NEW_FILES} مستندات فقط.`);

    }

    // Validate cumulative size limit
    if (cumulativeSize > MAX_TOTAL_NEW_SIZE) {
      this.isProcessingFiles = false;
      this.disableSaveNext = false;
      this.cd.detectChanges();
      return;
    }

    const allowedExtensions = ['pdf', 'jpeg'];
    const maxSizeBytes = 20 * 1024 * 1024; // 20 MB per file

    const validFiles: File[] = [];
    const invalidFiles: string[] = [];

    // Validate each new file's type and size
    for (const file of newBatchFilesArr) {
      const ext = file.name.split('.').pop()?.toLowerCase() || '';

      if (!allowedExtensions.includes(ext)) {
        this.fileTypeErr = true;
        invalidFiles.push(file.name);
        continue;
      }

      if (file.size > maxSizeBytes) {
        this.showSizeErr = true;
        invalidFiles.push(file.name);
        continue;
      }

      validFiles.push(file);
    }

    if (invalidFiles.length > 0) {
      this.isFileUploaded = false;
      alert(`Invalid files: ${invalidFiles.join(', ')}`);
      this.isProcessingFiles = false;
      this.disableSaveNext = false;
      this.cd.detectChanges();
      return;
    }

    if (validFiles.length === 0) {
      // For actionType edit, clear files if needed
      if (actionType === 'edit' && currentQuestion.files.length > 0) {
        currentQuestion.files = [];
      }
      this.isProcessingFiles = false;
      this.disableSaveNext = false;
      this.cd.detectChanges();
      return;
    }

    // Prevent duplicates by filename considering existing files
    const existingFileNames = new Set(currentQuestion.files.map((f: any) => f.filename));
    const newFilesToAdd = validFiles.filter(f => !existingFileNames.has(f.name));

    try {
      // Convert valid new files to base64
      const base64DataUrls = await Promise.all(newFilesToAdd.map(file => this.commonService.fileToBase64(file)));

      const newFileObjects = newFilesToAdd.map((file, i) => {
        const pureBase64 = base64DataUrls[i].split(',')[1]; // remove prefix
        return {
          filename: file.name,
          documentbody: pureBase64,
          isExisting: false,
          size: file.size // store size for size calculations
        };
      });

      if (actionType === 'edit') {
        // Replace file list on edit
        currentQuestion.files = newFileObjects;
        this.isFileChanged = true;
      } else {
        // Append new files
        currentQuestion.files = [...currentQuestion.files, ...newFileObjects];
      }

      this.isFileUploaded = true;
    } catch (error) {
      console.error('Error converting files to base64:', error);
      this.isFileUploaded = false;
      this.isProcessingFiles = false;
      this.disableSaveNext = false;
      this.cd.detectChanges();
      alert('There was an error processing your files.');
      return;
    }

    // Reset file input field to allow re-selection of same file(s)
    evt.target.value = '';

    this.isProcessingFiles = false;
    this.disableSaveNext = false;
    this.cd.detectChanges(); // Force UI to update the button and other bindings
  }
  // Helper method to estimate size for base64 strings (if needed)
  estimateFileSizeFromBase64(base64Str: string): number {
    if (!base64Str) return 0;
    const padding = (base64Str.match(/=+$/) || [''])[0].length;
    return (base64Str.length * 3) / 4 - padding;
  }
  async onFileUpload(actionType: any) {
    const file = this.fileToUpload;
    if (!file) {
      console.error('No file selected to upload.');
      return;
    }

    try {
      const result = await this.commonService.fileToBase64(file);
      this.fileToUploadBase64 = result;
      this.isFileUploaded = true;
      if (actionType === 'edit') {
        this.isFileChanged = true;
      }
    } catch (error) {
      console.error('Error during file conversion:', error);
      this.isFileUploaded = false;
    }
  }


  approveOrRejectQues(status: string) {
    this.status = status;
    if ((this.allQuestions[0].fields[this.selectedQues].comments == undefined ||
      this.allQuestions[0].fields[this.selectedQues].comments == 'undefined' ||
      this.allQuestions[0].fields[this.selectedQues].comments == null ||
      this.allQuestions[0].fields[this.selectedQues].comments == 'null' ||
      this.allQuestions[0].fields[this.selectedQues].comments.trim() == '')
      && status == 'reject' &&
      ((this.allQuestions[0]?.fields[this.selectedQues].statusOfResponse ==
        GlobalConstants.STATUSES.MAKER_SUBMITTED.name) ||
        (this.allQuestions[0]?.fields[this.selectedQues].statusOfResponse ==
          GlobalConstants.STATUSES.SUBMITTED.name))
    ) {
      this.showCommentErr = true;
    } else {
      this.showCommentErr = false;

      if (this.allQuestions[0].fields[this.selectedQues].comments != undefined &&
        this.allQuestions[0].fields[this.selectedQues].comments != 'undefined' &&
        this.allQuestions[0].fields[this.selectedQues].comments != null &&
        this.allQuestions[0].fields[this.selectedQues].comments != 'null' &&
        this.allQuestions[0].fields[this.selectedQues].comments.trim() != '') {
        let history;
        const currentDate = new Date();

        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = currentDate.getFullYear();

        let dateString = `${day}.${month}.${year}`;
        let userComment = `${this.userDetails?.firstname} ${this.userDetails?.lastname} - ${dateString} : ${this.allQuestions[0].fields[this.selectedQues].comments}`;

        if (this.allQuestions[0].fields[this.selectedQues]?.commentHistory &&
          this.allQuestions[0].fields[this.selectedQues]?.commentHistory != '') {
          history = userComment  + "\n" + this.allQuestions[0].fields[this.selectedQues]?.commentHistory;
        }
        else if (this.allQuestions[0].fields[this.selectedQues]?.commentHistory == '' ||
          this.allQuestions[0].fields[this.selectedQues]?.commentHistory == null ||
          this.allQuestions[0].fields[this.selectedQues]?.commentHistory == undefined ||
          this.allQuestions[0].fields[this.selectedQues]?.commentHistory == 'null' ||
          this.allQuestions[0].fields[this.selectedQues]?.commentHistory == 'undefined'
        ) {
          history = userComment;
        }
        // this.allQuestions[0].fields[this.selectedQues].commentHistory = history;
        // this.allQuestions[0].fields[this.selectedQues].comments = '';

        //to be assigned to ques after successful submit
        this.checkerHistory = history;
        this.checkerComment = '';
      }

      this.onSubmit();
    }


  }

  commentEnter() {
    this.showCommentErr = false;
    this.showAlphanumericCommentErr = false;
    this.showNumericCommentErr = false;
  }


  onSubmit() {

    const currentQuestion = this.allQuestions[0].fields[this.selectedQues];
    const quesId = currentQuestion.quesId;
    const quesDescription = currentQuestion.label;
    const quesType = currentQuestion.quesType;
    const numberOfResponses = currentQuestion.controls.length;

    this.emitSubmitEventToChild(true);
    this.submitted = true;

    // --- FILE UPLOAD VALIDATION ---
    const MAX_NEW_FILES = 10;
    const MAX_TOTAL_SIZE = 20 * 1024 * 1024; // 20 MB
    currentQuestion.files = currentQuestion.files || [];
    const newFiles = currentQuestion.files.filter((f: any) => !f.isExisting);

    if (newFiles.length > MAX_NEW_FILES) {
      return !this.isArabic ? alert(`You can only attach up to ${MAX_NEW_FILES} new files.`) : alert(`يمكنك إرفاق ما يصل إلى ${MAX_NEW_FILES} مستندات فقط.`);
    }

    const totalFilesSize = newFiles.reduce((sum: any, f: any) => sum + (f.documentbody || 0), 0);
    if (totalFilesSize > MAX_TOTAL_SIZE) {
      return !this.isArabic ? alert('Total size of newly selected files exceeds the 20 MB limit. Please select fewer or smaller files.') : alert('يجب ألا يتجاوز الحجم الإجمالي لجميع الملفات المضافة حديثًا 20 ميجابايت.');

    }

    if (
      currentQuestion.notesRequired &&
      (!this.isFileUploaded) &&
      (!currentQuestion.fileNames || currentQuestion.fileNames.length === 0)
    ) {
      this.isquesValid = false;
      console.warn('Validation failed: notes required but no files found');
      return !this.isArabic ? alert('Please upload at least one file.') : alert("يرجى تحميل ملف واحد على الأقل.");
    }

    // --- COMMENTS VALIDATION ---
    if (
      (currentQuestion.iscommentsmandatory ||
        (currentQuestion.commentsmandatoryforoptionnumber &&
          this.parentQuesAns?.selectedValueIndex.includes(currentQuestion.commentsmandatoryforoptionnumber - 1)
        ))
      &&
      (!currentQuestion.comments || currentQuestion.comments.trim() === '') &&
      !this.isChecker
    ) {
      this.isquesValid = false;
      this.showCommentErr = true;
      console.warn('Validation failed: mandatory comments missing');
      return !this.isArabic ? alert('Validation failed: mandatory comments missing.') : alert("فشلت عملية التحقق: التعليقات الإلزامية مفقودة.");

    }

    if (
      currentQuestion.comments &&
      currentQuestion.comments.length > 0 &&
      !this.isChecker &&
      this.checkIfInvalidComment()
    ) {
      this.isquesValid = false;
      console.warn('Validation failed: comments do not pass custom validation');
      return !this.isArabic ? alert('Validation failed: comments do not pass custom validation.') : alert("فشلت عملية التحقق: لم تجتز التعليقات التحقق المخصص.");
      ;
    }

    // --- EXECUTOR RESPONSES VALIDATION ---
    let countValidControl = 0;
    if (this.executorResp?.length > 0) {
      this.executorResp.forEach((ele: any, idx: number) => {
        if (ele.isValid && ele.value !== '-1' && ele.value !== '') {
          countValidControl++;
        } else {
          console.warn(`Validation failed: executor response index ${idx} invalid`, ele);
        }
      });
    }
    this.isquesValid = this.executorResp?.length === countValidControl;
    if (!this.isquesValid) {
      console.warn('Validation failed: not all executor responses are valid');
      return !this.isArabic ? alert('Please select valid options for all required fields.') : alert("يرجى اختيار خيارات صالحة لجميع الحقول المطلوبة.");

    }

    if (this.showSizeErr || this.fileTypeErr) {
      console.warn('Validation failed: file size/type error detected', {
        showSizeErr: this.showSizeErr,
        fileTypeErr: this.fileTypeErr
      });
      return;
    }

    // --- SYNC FORM VALUES BACK TO QUESTION CONTROLS ---
    currentQuestion.controls.forEach((ctrl: any, idx: number) => {
      if (ctrl.type === 'multiselect' || ctrl.type === 'country') {
        ctrl.value = this.executorResp[idx]?.value || '';
      } else {
        ctrl.value = this.controlAssessmentForm.get(`${quesId}_id_${idx}`)?.value || '';
      }
    });

    // --- BUILD EXECUTOR RESPONSE STRING ---
    let executorResp = '';
    for (let i = 0; i < numberOfResponses; i++) {
      if (i > 0) executorResp += ';';
      executorResp += currentQuestion.controls[i].value || '';
    }
    // console.log('Prepared executor response:', executorResp);

    // --- BUILD REQUEST BODY ---
    let rqstBody: any = {
      designRating: null,
      operatingRating: null,
      executorResponse: executorResp,
      assessmentunitguid: this.assessmentDetails.assessmentunitguid,
      quesnaireguid: this.questionaireguid,
      quesnaireaccountguid: this.questionnaireAccountGuid,
      quesguid: currentQuestion.quesguid,
      contactguid: this.userDetails.contactguid,
      quesSubmitTime: new Date(),
      quesDesc: quesDescription,
      quesType: quesType,
      assessmentType: this.questionnaireType,
      responseId: currentQuestion.responseId,
      isResubmit: this.isResubmit,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled,
      checkerApprovalStatus: this.status,
      comments: currentQuestion.comments,
    };

    if (this.isChecker) {
      rqstBody.commentHistory = this.checkerHistory;
      rqstBody.comments = this.checkerComment;

      currentQuestion.commentHistory = this.checkerHistory;
      currentQuestion.comments = this.checkerComment;

      this.checkerHistory = '';
      this.checkerComment = '';
      // console.log('Checker comments and history set');
    }

    // console.log('Final submit request body:', rqstBody);

    // --- CALL SUBMIT ---
    this.callQuesSubmit(rqstBody, quesId);
    // console.log('callQuesSubmit invoked');
  }
  openConfirmationComp(rqstBody: any, quesId: any) {
    let message = '';
    let messageOne = '';
    if (this.isArabic) {
      message = 'سيعيد هذا الإجراء تقديم السؤال.';
      messageOne = 'هل انت متأكد من رغبتك في التقدم؟';
    } else {
      message = 'This action will resubmit the question.';
      messageOne = 'Are you sure you want to proceed ?';
    }

    const initialState = {
      message: message,
      messageOne: messageOne,
      redirectTo: '',
      cancelButton: true
    };
    this.modalRef = this.modalService.show(NotificationComponent, { initialState });
    this.subscriptionNotify = this.categoryService.confirmationStatus$.subscribe((value) => {
      if (value == 'ok') {
        this.categoryService.setConfirmation(null);
        this.callQuesSubmit(rqstBody, quesId);
      }
    });
  }


  callQuesSubmit(rqstBody: any, quesId: any) {
    // console.log(`Submitting question index: ${this.selectedQues}`);
    this.disableSaveNext = true;

    // console.log('Save & Next button disabled.');

    const questionguid = this.allQuestions[0].fields[this.selectedQues].quesguid;
    // console.log(`Question GUID: ${questionguid}`);

    const currTimeStamp = new Date().getTime();
    if (!this.quesSubmitMapper[questionguid]) {
      this.quesSubmitMapper[questionguid] = currTimeStamp;
      // console.log(`Mapping question GUID timestamp: ${currTimeStamp}`);

      if (this.isChecker && !this.isResubmit) {
        if (this.allQuestions[0].fields[this.selectedQues].statusOfResponse == GlobalConstants.STATUSES.MAKER_SUBMITTED.name) {
          this.isCountChange = true;
          // console.log('isCountChange set to TRUE due to MAKER_SUBMITTED status.');
        } else {
          this.isCountChange = false;
          // console.log('Checking for linked child questions with MAKER_SUBMITTED status...');

          const childsIds = this.allQuestions[0].fields[this.selectedQues].controls[0]?.linkedChild?.map((item: any) => item.childQuesId) || [];
          const childs = this.allQuestions[0].fields.filter((item: any) => {
            const isLinkedChild = childsIds.includes(item?.quesId);
            const isStatus = item?.statusOfResponse == GlobalConstants.STATUSES.MAKER_SUBMITTED.name;
            return isLinkedChild && isStatus;
          });
          if (childs.length > 0) {
            this.isCountChange = true;
            // console.log(`Found ${childs.length} linked child(ren) with MAKER_SUBMITTED status.`);
          }
        }
      }

      // console.log('Calling saveQuestionResponse API with request body:', rqstBody);

      this.assessmentService.saveQuestionResponse(rqstBody).subscribe({
        next: (data: any) => {
          if (data?.error) {
            console.error('Save question response error:', data.error);
            this.showDeactivationPopup();
            this.disableSaveNext = false;
            return;
          }
          let decryptedData = this.commonService.decryptUsingAES256(data?.data);
          // console.log('Save response decrypted data:', decryptedData);


          if (decryptedData?.isDrafted === true) {
            this.submitted = false;
            this.quesSubmitMapper[questionguid] = 0;
            // if (this.isResubmit) {
            //   this.resubmittedCount++
            //   this.storageService.setSessionStorageData('resubmittedCount', this.resubmittedCount);
            //   console.log("resubmittedCount ", this.resubmittedCount)

            // }
            const currentQuestion = this.allQuestions[0].fields[this.selectedQues];

            // Cache savedResponses as before
            this.allQuestions[0].fields[this.selectedQues].savedResponses = [...this.executorResp];

            // Cache files array as savedFiles to restore later
            this.allQuestions[0].fields[this.selectedQues].savedFiles = [...(currentQuestion.files || [])];

            // console.log('Cached savedResponses and savedFiles:', {
            //   responses: this.allQuestions[0].fields[this.selectedQues].savedResponses,
            //   files: this.allQuestions[0].fields[this.selectedQues].savedFiles
            // });
            // console.log('Response is drafted.');

            if (this.allQuestions[0].fields[this.selectedQues].responseId == undefined || this.allQuestions[0].fields[this.selectedQues].responseId == null) {
              // console.log('Fetching new Response ID...');
              this.fetchResponseId(quesId, questionguid, false, this.selectedQues);
            } else if (this.isChecker && !this.isResubmit) {
              // console.log('Uploading files for checker...');
              // console.log('Files to upload:', this.allQuestions[0].fields[this.selectedQues].files);
              this.uploadFileToServer(quesId);
              // this.handleFileUploadAndProgress(quesId);
            } else {
              // console.log('Uploading files...');
              // console.log('Files to upload:', this.allQuestions[0].fields[this.selectedQues].files);
              this.uploadFileToServer(quesId);
              // this.handleFileUploadAndProgress(quesId);
            }
          } else {
            // console.log('Response is not drafted, resetting quesSubmitMapper timestamp.');
            this.quesSubmitMapper[questionguid] = 0;
            this.goToNextQuestion();
          }
          // console.log('Save & Next button enabled.');
        },
        error: (error: any) => {
          console.error('Save question response request failed:', error);
          if (error?.body?.error === 'The Assossicated Assessment Entity has deactivated') {
            this.showDeactivationPopup();
          } else {
            this.serverErr = error?.body?.error;
          }
          this.disableSaveNext = false;
          this.quesSubmitMapper[questionguid] = 0;
          // console.log('Save & Next button enabled after error.');
        }
      });
    } else {
      console.warn(`Duplicate submission prevented for question GUID: ${questionguid}`);
    }
  }

  resetErrorFlags() {
    this.serverErr = '';
    this.showCommentErr = false;
    this.showAlphanumericCommentErr = false;
    this.showNumericCommentErr = false;
    this.isFileUploaded = undefined;
    this.showSizeErr = false;
    this.fileTypeErr = false;
    this.executorResp = [];
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRefDeactivate = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  fetchResponseId(quesId: any, quesguid: any, isToggle: boolean,
    selectedQuesIndex: any, isParentAlreadySubmitted?: boolean) {
    let progressIncrease = 0;
    if (isToggle) {
      if ((isParentAlreadySubmitted &&
        (this.allQuestions[0].fields[selectedQuesIndex].responseId == undefined ||
          this.allQuestions[0].fields[selectedQuesIndex].responseId == null)) ||
        (!isParentAlreadySubmitted && this.allQuestions[0].fields[selectedQuesIndex].responseId)) {
        progressIncrease = 1;
      } else if (!isParentAlreadySubmitted &&
        (this.allQuestions[0].fields[selectedQuesIndex].responseId == undefined ||
          this.allQuestions[0].fields[selectedQuesIndex].responseId == null)) {
        progressIncrease = 2;
      }
    }
    if (this.allQuestions[0].fields[selectedQuesIndex].responseId == undefined || this.allQuestions[0].fields[selectedQuesIndex].responseId == null) {
      const rqstBodytoId = {
        questionnaire: this.questionaireguid,
        questionId: quesguid,
        assessmentUnit: this.userDetails.assessmentUnitValue
      }
      this.assessmentService.fetchExecutorResponseId(rqstBodytoId).subscribe((dataId: any) => {
        let decryptedDataId = this.commonService.decryptUsingAES256(dataId?.data);
        if (decryptedDataId?.responseId) {
          // this.responseId = decryptedDataId?.responseId;
          this.allQuestions[0].fields[selectedQuesIndex].responseId = decryptedDataId?.responseId;
          // console.log('responseID: ',this.responseId);
          if (isToggle) {
            if (progressIncrease > 0) {
              this.updateQuestionnaireProgress(isToggle, progressIncrease);
            } else {
              this.goToNextQuestion();
            }
          } else {
            this.uploadFileToServer(quesId);
          }
        }
      });
    } else {
      if (isToggle) {
        this.goToNextQuestion();
      }
    }
  }
  uploadFileToServer(quesId: any) {
    // console.log('uploadFileToServer called for quesId:', quesId);
    // console.log('isFileUploaded:', this.isFileUploaded, 'showSizeErr:', this.showSizeErr, 'fileTypeErr:', this.fileTypeErr, 'isFileChanged:', this.isFileChanged);

    const question = this.allQuestions[0].fields[this.selectedQues];
    const hasExistingFiles = question.files && question.files.length > 0;

    if ((this.isFileUploaded === undefined || !this.isFileUploaded) && !hasExistingFiles) {
      // No new files uploaded and no existing files present
      // console.log('No files to upload or existing files. Proceeding to update progress and next question.');
      this.updateProgressAndNextQues();
    }
    else if (!this.showSizeErr && !this.fileTypeErr && (this.isFileUploaded || hasExistingFiles)) {
      // Files present and no errors, proceed with uploading as needed
      if (this.isFileChanged) {
        const rqstBody4 = {
          responseguid: question.responseId
        };
        this.assessmentService.deleteFileFromServer(rqstBody4).subscribe({
          next: (data4) => {
            let decryptedData3 = this.commonService.decryptUsingAES256(data4?.data);
            this.callUploadFiles(quesId).then(() => {
              this.updateProgressAndNextQues();
            });
          },
          error: (err) => {
            console.error('Failed to delete files on server:', err);
            this.disableSaveNext = false;
            // optionally notify user here
          }
        });
      }
      else {
        this.callUploadFiles(quesId).then(() => {
          this.updateProgressAndNextQues();
        });
      }
    }
    else {
      console.warn('File upload conditions not met or file errors detected. Not proceeding with upload.');
      // Depending on flow, consider updating progress or enabling buttons here
    }
  }

  // Show popup and reset progress
  showUploadPopup() {
    this.disableSaveNext = true
    const overlay = document.querySelector('.upload-overlay') as HTMLElement;

    const popup = document.getElementById('uploadPopup');
    const progressBar = document.getElementById('uploadProgressBar') as HTMLProgressElement;
    const progressPercent = document.getElementById('progressPercent');

    if (popup && progressBar && progressPercent) {
      popup.style.display = 'block';
      progressBar.value = 0;
      progressPercent.textContent = '0%';
    }
    if (overlay) overlay.style.display = 'block';

  }

  // Update progress
  updateUploadProgress(percent: number) {
    // console.log('updateUploadProgress called with percent:', percent);  // <-- DEBUG 

    const progressBar = document.getElementById('uploadProgressBar') as HTMLProgressElement;
    const progressPercent = document.getElementById('progressPercent');


    if (progressBar && progressPercent) {
      progressBar.value = percent;
      progressPercent.textContent = `${percent}%`;
      this.cd.detectChanges();

    }
  }

  // Hide popup
  hideUploadPopup() {
    const popup = document.getElementById('uploadPopup');
    if (popup) {
      popup.style.display = 'none';
      this.disableSaveNext = false
    }
    const overlay = document.querySelector('.upload-overlay') as HTMLElement;
    if (overlay) overlay.style.display = 'none';
  }

  async callUploadFiles(quesId: any) {
    const files = this.allQuestions[0].fields[this.selectedQues].files || [];

    if (files.length === 0) {
      return Promise.resolve();
    }

    const newFiles = files.filter((file: any) => !file.isExisting);

    if (newFiles.length === 0) {
      return Promise.resolve();
    }

    this.isUploading = true;
    this.fileUploadErr = false;

    this.showUploadPopup();
    this.updateUploadProgress(0);

    try {
      const totalFiles = newFiles.length;
      let uploadedFiles = 0;

      for (const file of newFiles) {
        const rqstBody = {
          subjectId: quesId,
          filename: file.filename,
          responseguid: this.allQuestions[0].fields[this.selectedQues].responseId,
          documentBody: file.documentbody,
          notesType: 'quesNotes'
        };

        // Upload the file to server and await completion
        const res = await this.assessmentService.uploadFileToServer(rqstBody).toPromise();
        const decrypted = this.commonService.decryptUsingAES256(res?.data);

        if (decrypted?.isUploaded !== true) {
          throw new Error(`Upload failed for file: ${file.filename}`);
        }

        uploadedFiles++;
        // Update progress bar percentage (simple per-file progress)
        const percentDone = Math.round((uploadedFiles / totalFiles) * 100);
        this.updateUploadProgress(percentDone);
        // console.log('New files to upload:', newFiles);
        // console.log('Total files:', totalFiles);
      }

    } catch (error) {
      console.error('Upload files error:', error);
      this.fileUploadErr = true;
      // optionally you can add user notifications here for failure
      throw error; // optionally rethrow if you want upstream handlers to know
    } finally {
      this.isUploading = false;
      this.hideUploadPopup();
    }
  }
  updateProgressAndNextQues() {
    // console.log('Updating progress and moving to next question');

    let isParentAlreadySubmitted = !!this.ifAlreadySubmitted;

    if (this.isChecker && !this.isResubmit && this.status == 'reject') {
      this.rejectQuestionChain(this.parentQuesAns, isParentAlreadySubmitted);
    } else {
      this.toggleSubFieldsByEvent(this.parentQuesAns, isParentAlreadySubmitted);
    }


  }

  toggleSubFieldsByEvent(parentQuesAns: any, isParentAlreadySubmitted: boolean) {
    let saveNullValue = false;
    let nullValuesList: any = [];
    let revisitSubQuestionsList: any = [];
    let selectedQuesControlId = parentQuesAns?.parentQuesId;
    let questionguid = this.allQuestions[0].fields[this.selectedQues].quesguid;
    let parentQuesVal = (typeof (parentQuesAns.parentQuesValue) !== 'string') ?
      parentQuesAns.parentQuesValue?.toString() : parentQuesAns.parentQuesValue;
    let quesDescription: any;
    let quesType: any;
    let status: any;
    let comments: any;
    let quesId: any;

    // === Populating revisitSubQuestionsList and nullValuesList based on parent question answer ===
    this.allQuestions[0].fields.filter((ques: any) => ques.quesguid == questionguid).forEach((question: any) => {
      question.controls.forEach((quesControl: any, controlIndex: any) => {
        if (quesControl?.linkedChild && quesControl?.linkedChild.length > 0) {
          quesControl?.linkedChild.forEach((child: any) => {
            if ((child.parentQuesId + '_id_' + controlIndex) == parentQuesAns?.parentQuesId) {
              this.allQuestions[0].fields?.filter((ques: any) => ques.quesId == child.childQuesId).map((item: any) => {
                if (parentQuesVal?.toLowerCase()?.split(",")?.includes(child.parentResponseValue?.toLowerCase())) {
                  item.isHidden = false;
                  item.controls.forEach((control: any) => control.isHidden = false);
                  if (item.responseId) {
                    revisitSubQuestionsList.push(item);
                  }
                  // For nested child questions, add to nullValuesList with true flag to add nested children as N/A
                  this.addNestedItemsToList(nullValuesList, item, true);
                } else {
                  if (!item.isHidden) {
                    item.isHidden = true;
                    // console.log(`Hiding question: ${item.quesId} because of parent response or other condition.`);
                    item.controls.forEach((control: any) => control.isHidden = true);
                    this.addToNAList(nullValuesList, item);
                  }
                }
                return item;
              })
            }
          });
        } else if (question.isHidden) {
          // Handle multi-select or single-select based on dependency and basedOnValue
          let parentIdx = this.allQuestions[0]?.fields?.findIndex((quesParent: any) => quesParent?.quesId == quesControl?.dependsOn);
          if (parentIdx > -1) {
            if (this.allQuestions[0]?.fields[parentIdx]?.controls[0]?.type == 'multiselect') {
              let parentQuesRespArr = parentQuesVal?.split(',');
              let idx = parentQuesRespArr?.findIndex((eleResp: any) => eleResp?.toLowerCase() == quesControl?.basedOnValue?.toLowerCase());
              if (idx > -1) {
                quesControl.isHidden = false;
                question.isHidden = false;
                if (quesControl.validation && Object.keys(quesControl.validation).length > 0) {
                  let validators = this.quesValidationService.addValidation(quesControl.validation);
                  this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.setValidators(validators);
                  this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.updateValueAndValidity();
                }
              } else {
                this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.setValue(null);
                quesControl.isHidden = true;
                quesControl.value = null;
                question.isHidden = true;
                // console.log(`Hiding question: ${question.quesId} because of parent response or other condition.`);

                quesDescription = question.label;
                saveNullValue = true;
                selectedQuesControlId = question.quesId + '_id_' + controlIndex;
                questionguid = question.quesguid;
                comments = question.comments;
                quesId = question.quesId;
                quesType = question.quesType;
                this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.clearValidators();
                this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.updateValueAndValidity();
              }
            } else {
              this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.setValue(null);
              quesControl.isHidden = true;
              quesControl.value = null;
              question.isHidden = true;
              // console.log(`Hiding question: ${question.quesId} because of parent response or other condition.`);

              quesDescription = question.label;
              saveNullValue = true;
              selectedQuesControlId = question.quesId + '_id_' + controlIndex;
              questionguid = question.quesguid;
              comments = question.comments;
              quesId = question.quesId;
              quesType = question.quesType;
              this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.clearValidators();
              this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.updateValueAndValidity();
            }
          } else {
            this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.setValue(null);
            quesControl.isHidden = true;
            quesControl.value = null;
            question.isHidden = true;

            quesDescription = question.label;
            saveNullValue = true;
            selectedQuesControlId = question.quesId + '_id_' + controlIndex;
            questionguid = question.quesguid;
            comments = question.comments;
            quesId = question.quesId;
            quesType = question.quesType;
            this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.clearValidators();
            this.controlAssessmentForm.get(question.quesId + '_id_' + controlIndex)?.updateValueAndValidity();
          }

          // If we need to save null (N/A) value
          if (saveNullValue) {
            const rqstBody = {
              designRating: null,
              operatingRating: null,
              executorResponse: GlobalConstants.BYPASS_QUESTION_RESPONSE_TEXT,
              assessmentunitguid: this.assessmentDetails.assessmentunitguid,
              quesnaireguid: this.questionaireguid,
              quesnaireaccountguid: this.questionnaireAccountGuid,
              quesguid: questionguid,
              contactguid: this.userDetails.contactguid,
              quesSubmitTime: new Date(),
              quesDesc: quesDescription,
              quesType: quesType,
              assessmentType: this.questionnaireType,
              responseId: this.allQuestions[0].fields[this.selectedQues + 1]?.responseId,
              isResubmit: this.isResubmit,
              isChecker: this.isChecker,
              isMakerCheckerEnabled: this.isMakerCheckerEnabled,
              checkerApprovalStatus: status,
              comments: (comments == undefined || comments == 'undefined' ||
                comments == null || comments == 'null' || comments.trim() == '') ? '' : comments
            };
            nullValuesList.push(rqstBody);
          }
        }
      });
    });

    // === Update revisitSubQuestionsList statuses and clear controls ===
    const OVERRIDE_STATUS = this.isChecker ? GlobalConstants.STATUSES.MAKER_SUBMITTED.name : undefined;
    revisitSubQuestionsList.forEach((ques: any) => {
      const matchedQuestion = this.allQuestions[0].fields.find((item: any) => item.quesguid === ques.quesguid);
      if (matchedQuestion) {
        matchedQuestion.statusOfResponse = OVERRIDE_STATUS;
        // matchedQuestion.controls.forEach((control: any) => control.value = null);
      }
    });

    // Prepare request body to update responses of revisit questions
    const rqstBodyRespGuids = {
      respguids: revisitSubQuestionsList?.map((item: any) => ({ id: item?.responseId }))
    };

    // API call chain to update revisit question responses and questionnaire progress
    this.assessmentService.updateQuestionResponses(rqstBodyRespGuids).pipe(
      mergeMap((data: any) => {
        let decryptedData = this.commonService.decryptUsingAES256(data.data);
        if (decryptedData?.isUpdated === true) {

          const changeCountStatus = -revisitSubQuestionsList.length;
          this.reduceQuesCount(true, changeCountStatus);

          const currentProgressStatus = this.calculateProgressStatus(true, changeCountStatus);
          const progressClamped = Math.min(Math.max(currentProgressStatus, 0), 100);

          const rqstBody2 = {
            assessmentunitguid: this.assessmentDetails.assessmentunitguid,
            quesnaireguid: this.questionaireguid,
            contactguid: this.userDetails.contactguid,
            submitTime: new Date(),
            progress: progressClamped,
            questionnaireAccountGuid: this.questionnaireAccountGuid,
            isResubmit: this.isResubmit,
            isChecker: this.isChecker
          };

          return this.assessmentService.updateQuestionnaireProgress(rqstBody2).pipe(
            map(data3 => ({ data3, currentProgressStatus }))
          );

        } else {
          return of(null);
        }
      }),
      catchError(error => {
        console.error('Error updating question responses or progress:', error);
        this.isUpdatingProgress = false;
        return of(null);
      })
    ).subscribe(result => {
      this.isUpdatingProgress = false;

      if (result && result.data3) {
        const { data3, currentProgressStatus } = result;
        let decryptedData3 = this.commonService.decryptUsingAES256(data3?.data);
        if (decryptedData3?.isUpdated === true) {
          if (!this.isResubmit) {
            this.storageService.setSessionStorageData('quesStatus', currentProgressStatus);
            this.categoryService.setProgressStatus(currentProgressStatus);
          }
          this.isUpdatingProgress = false;


          this.goToNextQuestion();
        } else {
          console.warn('updateQuestionnaireProgress: Server responded with isUpdated false');
          this.isUpdatingProgress = false;
        }
      } else {
        // Fallback navigation logic
        if (!this.isChecker || (this.isChecker && this.isResubmit)) {
          if (!isParentAlreadySubmitted) {
            const progress = this.calculateProgressStatus();
            if (Math.abs(progress - this.lastSavedProgress) >= 0.01) {
              this.lastSavedProgress = progress;
              this.updateQuestionnaireProgress();
            }
          } else {

            this.goToNextQuestion();
          }
        } else if (this.isChecker && !this.isResubmit) {
          if (this.isCountChange) {
            this.answeredCount = this.storageService.getSessionStorageData('answeredQues');
            this.reduceQuesCount();
          }
          this.isCountChange = false;

          this.goToNextQuestion();
        }
      }
    });

    // === Save null values list ===
    if (nullValuesList?.length > 0) {
      nullValuesList.forEach((value: any) => {
        // Recursively add nested child questions to nullValuesList
        this.allQuestions[0].fields?.filter((ques: any) => ques.quesguid == value.quesguid)
          .forEach((actualQuestion: any) => {
            this.addNestedItemsToList(nullValuesList, actualQuestion, true);
          });
      });

      of(nullValuesList).pipe(
        mergeAll(),
        mergeMap((request: any) =>
          this.assessmentService.saveQuestionResponse(request).pipe(
            map((data) => {
              let decryptedData = this.commonService.decryptUsingAES256(data?.data);
              if (decryptedData?.isDrafted === true) {
                this.quesSubmitMapper[questionguid] = 0;
              }
              return { quesguid: request.quesguid, isDrafted: decryptedData.isDrafted ? true : false };
            })
          )
        ),
        toArray(),
        switchMap(savedResponses => {
          const draftedResponseQuesIds = savedResponses.filter(item => item.isDrafted).map(item => item.quesguid);
          const rqstBodytoId = {
            questionnaire: this.questionaireguid,
            questionIds: draftedResponseQuesIds,
            assessmentUnit: this.userDetails.assessmentUnitValue
          };
          return this.assessmentService.fetchExecutorResponseIds(rqstBodytoId).pipe(
            map((dataIds: any) => {
              let ids = [];
              let decryptedData = this.commonService.decryptUsingAES256(dataIds?.data);
              if (decryptedData?.responseIds) {
                ids = decryptedData?.responseIds;
              }
              return ids;
            })
          );
        }),
        catchError(err => {
          console.error('Error in saving null values:', err);
          return of([]);
        })
      ).subscribe(linkedNAchildIds => {
        let childProgressIncrease = 0;
        let parentProgressIncrease = 0;
        let progressIncrease = 0;

        const childIdsNA = linkedNAchildIds.map((item: any) => item.quesId);
        const childQuestions = this.allQuestions[0].fields.filter((item: any) =>
          childIdsNA.includes(item?.quesguid)
        );

        if (this.isChecker) {
          const SUBMIT_STATUS_TO_CHECK = GlobalConstants.STATUSES.MAKER_SUBMITTED.name;
          parentProgressIncrease = (this.allQuestions[0].fields[this.selectedQues].statusOfResponse == SUBMIT_STATUS_TO_CHECK) ? 1 : 0;

          const childs = childQuestions.filter((item: any) => item?.statusOfResponse == SUBMIT_STATUS_TO_CHECK);
          childProgressIncrease = childs.length;

          if (parentProgressIncrease > 0) {
            this.allQuestions[0].fields[this.selectedQues].statusOfResponse = GlobalConstants.STATUSES.SUBMITTED.name;
          }
          childs.forEach((ques: any) => {
            this.allQuestions[0].fields.filter((item: any) =>
              item.quesguid == ques.quesguid)[0].statusOfResponse = GlobalConstants.STATUSES.SUBMITTED.name;
          });
        } else {
          parentProgressIncrease = !(this.allQuestions[0].fields[this.selectedQues]?.statusOfResponse) ? 1 : 0;
          const childs = childQuestions.filter((item: any) => !item?.statusOfResponse);
          childProgressIncrease = childs.length;

          if (parentProgressIncrease > 0 && this.allQuestions[0].fields[this.selectedQues] && this.allQuestions[0].fields[this.selectedQues]?.statusOfResponse) {
            this.allQuestions[0].fields[this.selectedQues].statusOfResponse = GlobalConstants.STATUSES.DRAFT.name;
          }
          childs.forEach((ques: any) => {
            this.allQuestions[0].fields.filter((item: any) =>
              item.quesguid == ques.quesguid)[0].statusOfResponse = GlobalConstants.STATUSES.DRAFT.name;
          });
        }

        progressIncrease = parentProgressIncrease + childProgressIncrease;

        linkedNAchildIds.forEach((value: any) => {
          this.allQuestions[0].fields.filter((item: any) => item.quesguid == value.quesId)[0].responseId = value?.respId;
        });

        if (!this.isChecker && progressIncrease > 0) {
          this.isUpdatingProgress = false
          this.updateQuestionnaireProgress(true, progressIncrease);
        } else if (this.isChecker && this.isCountChange && progressIncrease > 0) {
          this.isCountChange = false;
          this.isUpdatingProgress = false

          this.updateQuestionnaireProgress(true, progressIncrease);
        } else {
          this.goToNextQuestion();
        }
      });
    }
  }

  rejectQuestionChain(parentQuesAns: any, isParentAlreadySubmitted: boolean) {

    //populate hierarchy list
    let questionList: any = [];
    let subQuestionList: any = [];
    //find parent
    const rootParentInChain = this.findParent(this.allQuestions[0].fields[this.selectedQues]);
    this.addToQuestionChainList(questionList, rootParentInChain);
    this.addNestedItemsToList(questionList, rootParentInChain, false);

    //calculate subquestion length for navigate
    this.addNestedItemsToList(subQuestionList, this.allQuestions[0].fields[this.selectedQues])


    //Update in database
    let rqstBody = {
      respguids: questionList?.map((item: any) => {
        item["id"] = item?.responseId;
        return item;
      })
    }

    this.assessmentService.updateQuestionResponses(rqstBody).subscribe((data: any) => {
      let decryptedData = this.commonService.decryptUsingAES256(data.data);
      if (decryptedData?.isUpdated === true) {

        let changeCountStatus = subQuestionList.length;
        // this.reduceQuesCount(true, changeCountStatus);

        // this.updateQuestionnaireProgress(true, -revisitSubQuestionsList.length);
        let parentProgressIncrease = 0, childProgressIncrease = 0, progressIncrease = 0;
        let currentProgressStatus = this.calculateProgressStatus(true, changeCountStatus);

        if (this.isChecker) {
          const SUBMIT_STATUS_TO_CHECK = GlobalConstants.STATUSES.MAKER_SUBMITTED.name;
          //override
          parentProgressIncrease = (this.allQuestions[0].fields[this.selectedQues].statusOfResponse == SUBMIT_STATUS_TO_CHECK) ? 1 : 0;

          const childs = subQuestionList.filter((item: any) => item?.statusOfResponse == SUBMIT_STATUS_TO_CHECK);
          //override
          childProgressIncrease = childs?.length;

          //update app data with updated status before next api call to refresh data
          if (parentProgressIncrease > 0) {
            this.allQuestions[0].fields[this.selectedQues].statusOfResponse = GlobalConstants.STATUSES.SUBMITTED.name;
          }
          childs.forEach((ques: any) => {
            this.allQuestions[0].fields.filter((item: any) =>
              item.quesguid == ques.quesguid)[0].statusOfResponse = GlobalConstants.STATUSES.SUBMITTED.name;
          });

        }
        progressIncrease = parentProgressIncrease + childProgressIncrease;

        if (this.isChecker && this.isCountChange && progressIncrease > 0) {
          this.isCountChange = false;
          this.updateQuestionnaireProgress(true, progressIncrease);
        }
        else {
          this.goToNextQuestion();
        }

      }

    })

  }

  addNestedItemsToList(itemList: any, question: any, isNAList: boolean = false) {
    question?.controls?.forEach((quesControl: any) => {

      if (quesControl?.linkedChild?.length > 0) {

        quesControl?.linkedChild?.forEach((child: any) => {
          this.allQuestions[0].fields?.filter((ques: any) => ques.quesId == child.childQuesId).map((childQuestion: any) => {

            childQuestion.isHidden = true;
            childQuestion.controls.forEach((control: any) => control.isHidden = true);
            if (isNAList) {
              this.addToNAList(itemList, childQuestion);
            }
            else {
              this.addToQuestionChainList(itemList, childQuestion);
            }

            this.addNestedItemsToList(itemList, childQuestion);
          })

        })
      }
    })
    return;
  }

  findParent(question: any): any {
    if (!question?.hasParent) {
      return question;
    }
    else {
      const parent = this.allQuestions[0].fields?.find((parent: any) => parent?.quesguid == question?.parentguid)
      return parent ? this.findParent(parent) : question;
    }
  }

  addToQuestionChainList(list: any, item: any) {
    if (list?.filter((request: any) => request.quesguid == item.quesguid)?.length <= 0) {
      let userResponse = item?.controls[0]?.value;
      if (userResponse && userResponse == GlobalConstants.BYPASS_QUESTION_RESPONSE_TEXT) {
        userResponse = '';
      }
      const rqstBody = {
        executorResponse: userResponse,
        assessmentunitguid: this.assessmentDetails.assessmentunitguid,
        quesnaireguid: this.questionaireguid,
        quesnaireaccountguid: this.questionnaireAccountGuid,
        quesguid: item?.quesguid,
        contactguid: this.userDetails.contactguid,
        quesSubmitTime: new Date(),
        quesType: item?.quesType,
        assessmentType: this.questionnaireType,
        responseId: item?.responseId,
        isResubmit: this.isResubmit,
        isChecker: this.isChecker,
        isMakerCheckerEnabled: this.isMakerCheckerEnabled,
        checkerApprovalStatus: this.status,
      }
      list.push(rqstBody);
    }
  }
  addToNAList(list: any, item: any) {
    if (list?.filter((request: any) => request.quesguid == item.quesguid)?.length <= 0) {
      const rqstBody = {
        designRating: null,
        operatingRating: null,
        // executorResponse: 'N/A',
        executorResponse: GlobalConstants.BYPASS_QUESTION_RESPONSE_TEXT,
        assessmentunitguid: this.assessmentDetails.assessmentunitguid,
        quesnaireguid: this.questionaireguid,
        quesnaireaccountguid: this.questionnaireAccountGuid,
        quesguid: item?.quesguid,
        contactguid: this.userDetails.contactguid,
        quesSubmitTime: new Date(),
        quesDesc: item?.label,
        quesType: item?.quesType,
        assessmentType: this.questionnaireType,
        //responseId: this.allQuestions[0].fields[selectedQuesIndex]?.responseId,
        responseId: item?.responseId,
        isResubmit: this.isResubmit,
        isChecker: this.isChecker,
        isMakerCheckerEnabled: this.isMakerCheckerEnabled,
        checkerApprovalStatus: status,
        comments: (item?.comments == undefined || item?.comments == 'undefined' ||
          item?.comments == null || item?.comments == 'null' || item?.comments.trim() == '') ? '' : item?.comments
      }
      list.push(rqstBody);
    }
  }

  setQuestionVisibility() {
    this.allQuestions[0]?.fields?.forEach((question: any) => {
      question.controls.forEach((quesControl: any, controlIndex: any) => {

        if (quesControl?.linkedChild &&
          quesControl?.linkedChild?.length > 0
        ) {
          quesControl?.linkedChild.forEach((child: any) => {
            // if ((child.parentQuesId + '_id_' + controlIndex) == parentQuesAns?.parentQuesId) {
            this.allQuestions[0].fields?.filter((ques: any) => ques.quesId == child.childQuesId).map((item: any) => {
              if (quesControl?.value?.toLowerCase()?.split(",")?.includes(child.parentResponseValue?.toLowerCase())) {
                item.isHidden = false;
                item.controls.forEach((control: any) => control.isHidden = false);
              }
              else {
                item.isHidden = true;
                item.controls.forEach((control: any) => control.isHidden = true);
              }
              return item;
            })
            //}
          })
        }

      })
    })
  }
  isUpdatingProgress = false;
  lastSavedProgress: number = -1;
  assessmentProgressPercentage: number = 0;

  updateQuestionnaireProgress(isToggle?: boolean, progressIncrease?: any) {
    console.log('updateQuestionnaireProgress called, isUpdating:', this.isUpdatingProgress, 'progress:', this.assessmentProgressPercentage);

    if (this.isUpdatingProgress) {
      console.log('updateQuestionnaireProgress skipped because another call in progress');
      return;
    }
    let quesStatusVal = this.calculateProgressStatus(isToggle, progressIncrease);
    // console.log(quesStatusVal)
    // console.log(this.lastSavedProgress)
    // Check if progress has changed meaningfully (threshold 0.01)
    if (Math.abs(quesStatusVal - this.lastSavedProgress) < 0.01) {
      console.log(`Skipped update since progress unchanged: ${quesStatusVal}`);
      return;
    }
    this.isUpdatingProgress = true;
    this.lastSavedProgress = quesStatusVal;
    const rqstBody3 = {
      assessmentunitguid: this.assessmentDetails.assessmentunitguid,
      quesnaireguid: this.questionaireguid,
      contactguid: this.userDetails.contactguid,
      submitTime: new Date(),
      progress: quesStatusVal,
      questionnaireAccountGuid: this.questionnaireAccountGuid,
      isResubmit: this.isResubmit,
      isChecker: this.isChecker
    }
    console.log('percentage check: ', rqstBody3);
    this.assessmentService.updateQuestionnaireProgress(rqstBody3).subscribe((data3: any) => {
      let decryptedData3 = this.commonService.decryptUsingAES256(data3?.data);
      console.log(decryptedData3);
      if (decryptedData3?.isUpdated === true) {
        if (!this.isResubmit) {
          this.storageService.setSessionStorageData('quesStatus', quesStatusVal);
          this.categoryService.setProgressStatus(quesStatusVal);

          // if (isToggle && progressIncrease) {
          //   this.answeredCount = this.answeredCount + progressIncrease;
          //   this.storageService.setSessionStorageData('countReduce', progressIncrease);
          //   this.categoryService.setCountReduce(progressIncrease);
          // } else {
          //   this.answeredCount++;
          //   let progressCount = 1;
          //   this.categoryService.setCountReduce(progressCount);
          // }

          // this.storageService.setSessionStorageData('answeredQues', this.answeredCount);
          // this.categoryService.setCountOfAnswered(this.answeredCount);
          this.reduceQuesCount(isToggle, progressIncrease);
        }
        this.goToNextQuestion();
      }
    });
  }

  calculateProgressStatus(isToggle?: boolean, progressIncrease?: any) {
    let quesStatus = this.isResubmit ?
      this.assessmentDetails.questionnaireProgress :
      this.storageService.getSessionStorageData('quesStatus') || 0;

    let quesPercentage = this.quesPercentage || 0;

    let quesStatusVal = 0;

    if (isToggle && progressIncrease) {
      quesStatusVal = quesStatus + quesPercentage * progressIncrease;
    } else {
      quesStatusVal = quesStatus + quesPercentage;
    }

    // Clamp the value between 0 and 100:
    if (quesStatusVal > 100) {
      quesStatusVal = 100;
    }
    if (quesStatusVal < 0) {
      quesStatusVal = 0;
    }

    this.assessmentProgressPercentage = Number(quesStatusVal.toFixed(5));  // Update property here

    return this.assessmentProgressPercentage;
  }


  reduceQuesCount(isToggle?: any, progressIncrease?: any) {
    this.answeredCount = this.storageService.getSessionStorageData('answeredQues');
    if (isToggle && progressIncrease) {
      this.answeredCount = this.answeredCount + progressIncrease;
      this.storageService.setSessionStorageData('countReduce', progressIncrease);
      //assessmentProgressChange
      this.categoryService.setCountReduce(progressIncrease);
      this.categoryService.setAssessmentProgressChange(true);
    } else {
      this.answeredCount++;
      let progressCount = 1;
      //assessmentProgressChange
      this.categoryService.setCountReduce(progressCount);
      this.categoryService.setAssessmentProgressChange(true);
    }
    this.storageService.setSessionStorageData('answeredQues', this.answeredCount);
    //assessmentProgressChange
    this.categoryService.setCountOfAnswered(this.answeredCount);
    this.categoryService.setAssessmentProgressChange(true);
  }

  goToNextQuestion() {
    this.resetErrorFlags();
    // IMPORTANT: Clear previous question responses
    this.executorResp = [];
    window.scrollTo(0, 0);
    // Move to next question
    this.selectedQues++;
    // End of questionnaire
    if (this.selectedQues >= this.allQuestions[0].fields.length) {
      this.isCompleted = true;
      this.completedChange.emit();
      return;
    }
    // Skip all hidden questions
    while (
      this.selectedQues < this.allQuestions[0].fields.length &&
      this.allQuestions[0].fields[this.selectedQues].isHidden
    ) {
      // console.log(`Skipping hidden question: idx=${this.selectedQues}, QuesId=${this.allQuestions[0].fields[this.selectedQues].quesId}`);

      this.selectedQues++;
    }
    // Check again after skipping
    if (this.selectedQues >= this.allQuestions[0].fields.length) {
      this.isCompleted = true;
      // console.log('All questions completed');
      this.completedChange.emit();
      return;
    }
    // NOW update selected question
    this.setSelectedQuestionState();
    // Initialize executor response array
    this.executorResp = [];
    const currentQuestion = this.allQuestions[0].fields[this.selectedQues];
    if (currentQuestion?.controls?.length) {
      currentQuestion.controls.forEach(() => {
        this.executorResp.push({
          isValid: undefined,
          value: undefined
        });
      });
    }
    // Fetch uploaded files if required
    if (!currentQuestion.hasOwnProperty('fileName')) {
      this.fetchUploadedFiles();
    }
    this.disableSaveNext = false;
    // console.log(
    //   'Navigated to Question:',
    //   this.selectedQues,
    //   currentQuestion?.quesId,
    //   currentQuestion?.quesguid
    // );
  }
  loadSavedAnswers(questionIndex: number): void {
    const question = this.allQuestions[0].fields[questionIndex];
    if (!question) {
      console.warn(`loadSavedAnswers: No question at index ${questionIndex}`);
      return;
    }
    // console.log(`loadSavedAnswers: Loading saved answers for question: ${question.quesId}`, question);

    if (question.savedResponses && question.savedResponses.length > 0) {
      // console.log('Found savedResponses:', question.savedResponses);
      this.executorResp = [...question.savedResponses];
    } else {
      // console.log('No savedResponses found, initializing executorResp with undefined');
      this.executorResp = [];
      question.controls?.forEach(() => {
        this.executorResp.push({ isValid: undefined, value: undefined });
      });
    }

    // Confirm executorResp after loading
    // console.log('executorResp after loading:', this.executorResp);

    // Load file metadata and ensure files is an array (never undefined)
    if (question.savedFiles && question.savedFiles.length > 0) {
      // console.log('Restoring saved files:', question.savedFiles);
      question.files = [...question.savedFiles];
    } else {
      // console.log('No saved files found. Initializing empty files array.');
      question.files = [];
    }

    // Setting form controls from executorResp values
    question.controls?.forEach((control: any, index: number) => {
      const formControlName = `${question.quesId}_id_${index}`;
      const savedValue = this.executorResp[index]?.value;
      // console.log(`Setting form control [${formControlName}] =`, savedValue);

      // Check control exists before setting value
      const formControl = this.controlAssessmentForm.get(formControlName);
      if (formControl) {
        formControl.setValue(savedValue);
      } else {
        console.warn(`Form control ${formControlName} not found.`);
      }
    });

    // Force Angular change detection to update UI bindings
    this.cd.detectChanges();
  }
  goToPreviousQuestion() {
    this.disableSaveNext = true;
    window.scrollTo(0, 0);
    this.selectedQues--;

    if (this.allQuestions[0]?.fields[this.selectedQues]?.isHidden) {
      this.goToPreviousQuestion();
      return;
    }

    const question = this.allQuestions[0]?.fields[this.selectedQues];
    if (!question) {
      this.disableSaveNext = false;
      return;
    }

    // Load saved executor responses if available
    if (question.savedResponses && question.savedResponses.length > 0) {
      this.executorResp = [...question.savedResponses];
    } else {
      this.executorResp = [];
      question.controls.forEach(() => {
        this.executorResp.push({ isValid: undefined, value: undefined });
      });
    }

    // Patch form controls with saved values
    question.controls.forEach((control: any, idx: number) => {
      const controlName = `${question.quesId}_id_${idx}`;
      const savedValue = this.executorResp[idx]?.value;
      const formControl = this.controlAssessmentForm.get(controlName);
      if (formControl) {
        formControl.setValue(savedValue);
      }
    });

    // Load uploaded files if any saved
    if (question.savedFiles && question.savedFiles.length > 0) {
      question.files = [...question.savedFiles];
    }

    this.disableSaveNext = false;
  }
  goToInitialQuestion() {
    this.disableSaveNext = true;
    window.scrollTo(0, 0);
    this.isCompleted = false;
    this.fetchAndGenerateForm();
  }

  goToNextSubcategory() {
    this.subcategoryStatusCheck.emit(true);
  }

  checkIfInvalidComment() {
    // console.log("checking custom validation");
    let userComment = (this.allQuestions[0].fields[this.selectedQues].comments == undefined ||
      this.allQuestions[0]?.fields[this.selectedQues]?.comments == 'undefined' ||
      this.allQuestions[0]?.fields[this.selectedQues]?.comments == null ||
      this.allQuestions[0]?.fields[this.selectedQues]?.comments == 'null' ||
      this.allQuestions[0]?.fields[this.selectedQues]?.comments?.trim() == '') ?
      '' : this.allQuestions[0]?.fields[this.selectedQues]?.comments;
    const validationType = this.allQuestions[0].fields[this.selectedQues].commentboxtype;
    if (userComment && validationType && validationType == 'numeric') {
      this.showNumericCommentErr = true;
      let regex = new RegExp("^([0-9]*)$");
      if (regex.test(userComment)) {
        this.showNumericCommentErr = false;
        return false;
      }
    }
    //removing alphanumeric because now it contains all characters
    else if (userComment && validationType && validationType == 'alphanumeric') {
      this.showAlphanumericCommentErr = false;
      return false;
      // let regex = new RegExp("^([a-zA-Z0-9 ]+)$");
      // if (regex.test(userComment)) {
      //   this.showAlphanumericCommentErr = false;
      //   return false;
      // }
    }
    else {
      return false;
    }
    // else if (userComment == '') {
    //   this.showCommentErr = true;
    // }

    return true;
  }

  emitSubmitEventToChild(isSubmitted: boolean) {
    if (isSubmitted) {
      this.saveNextSubject.next();
    }
  }

  ngOnDestroy() {
    this.storageService.removeSessionStorageData('selectedQuestionState');
    this.unsubscribe();
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionNotify) {
      this.subscriptionNotify.unsubscribe();
    }
  }

  deleteFile(index: number, ques: any) {
    // console.log('Selected Ques index/key:', this.selectedQues);

    const currentQues = this.allQuestions[0]?.fields?.[this.selectedQues];
    // console.log('Current files before deletion:', JSON.stringify(currentQues.files, null, 2)); // stringify to see all props

    // console.log('ques.files:', ques?.files);
    // console.log('currentQues.files:', currentQues?.files);
    // console.log('ques.files === currentQues.files:', ques?.files === currentQues?.files);

    // Pick the one that matches your UI!
    const files = ques?.files ?? currentQues?.files;

    if (!files || !Array.isArray(files)) {
      console.warn('Files array not found or not an array');
      return;
    }

    if (index < 0 || index >= files.length) {
      console.warn('Index out of bounds', index);
      return;
    }

    const fileToDelete = files[index];
    // console.log('File selected for deletion:', fileToDelete);
    // console.log('fileToDelete.hasOwnProperty("isExisting"):', fileToDelete.hasOwnProperty('isExisting'));

    if (fileToDelete.isExisting) {
      // console.log('File is existing on server, attempting server delete.');

      const rqstBody = {
        responseguid: currentQues.responseId,
        annotationid: fileToDelete.annotationid,
      };

      // console.log('Delete request body:', rqstBody);


      this.assessmentService.deleteFileFromServer(rqstBody).subscribe({
        next: (res) => {
          // console.log('Server response from file delete:', res);
          const decryptedData = this.commonService.decryptUsingAES256(res?.data);
          // console.log('Decrypted server response data:', decryptedData);

          if (decryptedData?.isDeleted) {
            // Remove file locally after successful server delete
            // console.log('Removing file from local array at index:', index);
            currentQues.files.splice(index, 1);
            currentQues.files = [...currentQues.files]; // trigger change detection
            // console.log('Current files after deletion:', currentQues.files);

            this.isFileChanged = true;
            this.isFileUploaded = currentQues.files.length > 0;

            if (!this.isFileUploaded) {
              // console.log('No files remain after deletion; resetting error flags');
              this.fileTypeErr = false;
              this.showSizeErr = false;
              this.fileUploadErr = false;
            }
          } else {
            console.warn('Server delete did not confirm deletion');
            // Optionally notify user delete was unsuccessful
          }
        },
        error: (err) => {
          console.error('Failed to delete file on server:', err);
          // Optionally notify user of failure
        }
      });
    } else {
      // File is new and local only — delete immediately
      // console.log('File is new (not uploaded yet), deleting locally only.');

      currentQues.files.splice(index, 1);
      currentQues.files = [...currentQues.files]; // trigger change detection
      // console.log('Current files after local deletion:', currentQues.files);

      this.isFileUploaded = currentQues.files.length > 0;
      this.isFileChanged = true;

      if (!this.isFileUploaded) {
        // console.log('No files remain after local deletion; resetting error flags');
        this.fileTypeErr = false;
        this.showSizeErr = false;
        this.fileUploadErr = false;
      }
    }
    // console.log('File flags reset after deletion:', {
    //   isFileUploaded: this.isFileUploaded,
    //   fileTypeErr: this.fileTypeErr,
    //   showSizeErr: this.showSizeErr,
    //   fileUploadErr: this.fileUploadErr,
    //   disableSaveNext: this.disableSaveNext
    // });
    // Uncomment if you want to debug or manage disableSaveNext based on files
    // if(currentQues.files.length === 0){
    //   console.log('No files attached, enabling Save & Next button.');
    //   this.disableSaveNext= false;
    // }
  }
  // canShowEditDeleteIcons(file: any): boolean {

  //   if (file.isExisting && file.ownername !== 'AML CRMINT' && this.isView) {
  //     return false;
  //   }
  //   if (!file.isExisting && file.ownername == '' && !this.isResubmit && !this.isView) { //new add
  //     return true
  //   }

  //   if (this.isResubmit && file.isExisting) { //resubmit true
  //     return false;
  //   }
  //   return true;
  // }
  canShowEditDeleteIcons(file: any): boolean {
    if (!file) {
      return false;
    }

    if (this.isView) {
      return false;
    }

    const isExisting = Boolean(file.isExisting);

    if (this.isResubmit && isExisting) {
      return false;
    }

    // Show icons if not resubmitting and
    // either file is existing or it's new file when not viewing
    const isNewUnownedNotResubmit = !isExisting && !this.isResubmit && !this.isView;
    const isResubmitNewFile = this.isResubmit && !isExisting;

    return isExisting || isNewUnownedNotResubmit || isResubmitNewFile;
  }


  toggleDocuments(ques: any): void {
    ques.showDocuments = !ques.showDocuments;


  }
  toggleCrmDocuments(ques: any): void {
    ques.showCrmDocuments = !ques.showCrmDocuments;


  }
  onCrmDocumentsToggle(event: any, ques: any) {
    ques.showCrmDocuments = event.target.open;
  }
  onDocumentsToggle(event: any, ques: any) {
    ques.showDocuments = event.target.open;
  }
  sortCommentsByDateDesc(commentHistory: string): string {
  if (!commentHistory) return '';

  const comments = commentHistory.split('\n').filter(line => line.trim() !== '');

  // Parse date and create array of objects with date and original comment
  const commentsWithDate = comments.map(commentLine => {
    // Extract date with regex: looks for DD.MM.YYYY pattern anywhere after a dash
    const dateRegex = /- (\d{2})\.(\d{2})\.(\d{4})[: ]/;
    const match = commentLine.match(dateRegex);

    let dateObj: Date;

    if (match) {
      const day = Number(match[1]);
      const month = Number(match[2]) - 1; // JS months start from 0
      const year = Number(match[3]);
      dateObj = new Date(year, month, day);
    } else {
      // If no date found, assign an old date so it goes to the bottom
      dateObj = new Date(0);
    }

    return {
      line: commentLine,
      date: dateObj
    };
  });

  // Sort descending by date
  commentsWithDate.sort((a, b) => b.date.getTime() - a.date.getTime());
  // Join back lines
  return commentsWithDate.map(c => c.line).join('\n');
}

}
